import React from "react";
import { getItem } from "../../util/util";
import http from "../../util/api";
import { Modal, Toast } from "antd-mobile";
import moment from "moment";

const resid = "620992072227";
class BindServiceCorp extends React.Component {
  state = {
    visible: false
  };
  componentDidMount() {
    const isLogin = getItem("userInfo");
    if (isLogin) {
      const id = this.props.match.params.id;
      const cardID = JSON.parse(isLogin).UserCode;
      console.log(cardID);
      this.hasBindedToday(cardID, id);
    } else {
      this.setState({ visible: true });
    }
  }

  hasBindedToday = async (cardID, id) => {
    try {
      const res = await http().getTable({
        resid,
        cmswhere: `C3_620992149631 = '${cardID}' and C3_620992184992 = '${moment().format(
          "YYYY-MM-DD"
        )}'`
      });
      if (res.data.data.length) {
        Modal.alert(
          "提示",
          <div style={{ fontSize: 16, color: "#f22635" }}>
            今日不可再次绑定
          </div>,
          [
            {
              text: "我知道了",
              onPress: () => this.props.history.push("/personal_center")
            }
          ]
        );
      } else {
        this.bindServiceCorp(id);
      }
    } catch (error) {
      Toast.fail(error.message);
    }
  };

  bindServiceCorp = async id => {
    try {
      let res = await http().addRecords({
        resid,
        data: [{ C3_620992166040: id }]
      });
      const name = res.data.data[0].C3_620992173541;
      Modal.alert(
        "您的劳务公司",
        <div style={{ fontSize: 16, color: "#f22635" }}>{name}</div>,
        [
          {
            text: "我知道了",
            onPress: () =>
              Toast.info(
                "绑定劳务公司成功",
                this.props.history.push("/personal_center")
              )
          }
        ]
      );
    } catch (error) {
      console.log(error);
      Toast.fail("绑定出错");
    }
  };
  render() {
    return (
      <div>
        <Modal
          visible={this.state.visible}
          title="提示"
          transparent
          maskClosable={false}
        >
          <div>
            已有账号？请前往
            <a
              href="javascript:;"
              onClick={() => this.props.history.push("/login")}
            >
              登录
            </a>
          </div>
          <div>
            没有有账号？请前往
            <a
              href="javascript:;"
              onClick={() => this.props.history.push("/register")}
            >
              注册
            </a>
          </div>
        </Modal>
      </div>
    );
  }
}

export default BindServiceCorp;
